import * as React from 'react';
import { memo } from 'react';

import Image, { ImageProps } from 'components/atoms/Image';
import { LinkProps } from 'components/atoms/Link';

export type TeaserRoundPropsType = {
	link: LinkProps;
	categoryTitle: string;
	title: string;
	image: ImageProps;
	logo?: ImageProps;
};

export const TeaserRound = ({ link, categoryTitle, title, image, logo }: TeaserRoundPropsType) => {
	if (!link || !image) {
		return null;
	}

	const additionalLinkAttrs = link.openInNewWindow ? { target: '_blank' } : {};

	return (
		<div className="m-teaser-round">
			<a className="m-teaser-round__link" href={link.href} {...additionalLinkAttrs}>
				<div className="m-teaser-round__box">
					<div className="m-teaser-round__box-wrap">
						<div className="m-teaser-round__box-triangle" />
						<div className="m-teaser-round__box-text">{link.title}</div>
					</div>
					<div className="m-teaser-round__box-image-wrap">
						<div className="m-teaser-round__box-image">
							<Image
								srcset={image.srcset}
								alt={image.alt}
								original={image.original}
								title={image.title}
							/>
						</div>
					</div>
				</div>
				<div className="m-teaser-round__topic">
					<div className="m-teaser-round__topic-category">{categoryTitle}</div>
					<h3 className="m-teaser-round__topic-title">{title}</h3>
					{logo && (
						<div className="m-teaser-round__topic-logo">
							<Image srcset={logo.srcset} alt={logo.alt} original={logo.original} title={logo.title} />
						</div>
					)}
				</div>
			</a>
		</div>
	);
};

export default memo(TeaserRound);
